import { jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import Highlighter from 'react-highlight-words';

const useHighlight = (filterText) => {
    const filterWords = useMemo(() => {
        if (typeof filterText === 'string') {
            return [filterText];
        }
        else if (filterText) {
            return filterText;
        }
    }, [filterText]);
    return useCallback((text) => {
        if (text && filterWords) {
            return (jsx(Highlighter, { highlightClassName: "highlighted-text", searchWords: filterWords, autoEscape: true, textToHighlight: text, sanitize: text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '') }));
        }
        return text;
    }, [filterWords]);
};

export { useHighlight as default };
//# sourceMappingURL=useHighlight.js.map
